module.exports = __webpack_public_path__ + "assets/img/17_1415.2821c762.jpg";